import { useMemo } from 'react';
import useTable from "./useTable.js";
/**
 * Subscribe to viewport updates on a single table column
 * @param table Table to get the data from
 * @param firstRow First viewport row
 * @param lastRow Last viewport row
 * @param columnName Column to get the data from
 * @returns Column object, data array for the column, error, setViewport method
 */
var useTableColumn = (table, firstRow, lastRow, columnName) => {
  var columnNames = useMemo(() => [columnName], [columnName]);
  var _useTable = useTable(table, firstRow, lastRow, columnNames),
    _useTable$columns = _useTable.columns,
    columns = _useTable$columns === void 0 ? [] : _useTable$columns,
    _useTable$data = _useTable.data,
    data = _useTable$data === void 0 ? [] : _useTable$data,
    error = _useTable.error;
  return {
    column: columns[0],
    data: data[0],
    error
  };
};
export default useTableColumn;
//# sourceMappingURL=useTableColumn.js.map